export default {
      id: "harris-usage",
      viewBox: "0 0 148 39",
      url: __webpack_public_path__ + "sprite.svg#harris-usage",
      toString: function () {
        return this.url;
      }
    }